"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavMenuList = exports.NavMenuButton = exports.NavMenu = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var index_1 = require("../index");
var index_2 = require("../../../index");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var useHeaderProps_1 = require("../../hooks/useHeaderProps");
function NavMenu(props) {
    return React.createElement(react_1.Menu, __assign({ offset: [0, 7] }, props));
}
exports.NavMenu = NavMenu;
function NavMenuButton(props) {
    var colorSet = (0, useHeaderProps_1.useHeaderProps)().colorSet;
    return (React.createElement(react_1.MenuButton, __assign({ as: index_1.HeaderButton, rightIcon: React.createElement(index_2.Icon, { type: pro_solid_svg_icons_1.faChevronDown, color: colorSet === null || colorSet === void 0 ? void 0 : colorSet.text }) }, props)));
}
exports.NavMenuButton = NavMenuButton;
function NavMenuList(props) {
    return React.createElement(react_1.MenuList, __assign({ boxShadow: "md" }, props));
}
exports.NavMenuList = NavMenuList;
